// extracted by mini-css-extract-plugin
module.exports = {"c_checkbox_input":"Checkbox_c_checkbox_input__VDkdv","c_checkbox_dummyInput":"Checkbox_c_checkbox_dummyInput__zqbyB"};